import React from "react";

const Text = props => {
    return (
        <span
            {...props.attributes}
            style={{
                fontWeight: props.leaf.bold ? "bold" : "normal",
                ...(props.leaf.italic && { fontStyle: "italic" }),
                ...(props.leaf.underline && { textDecoration: "underline" }),
                ...(props.leaf.strikethrough && { textDecoration: "line-through" })
            }}
        >
            {props.children}
        </span>
    )
}

export default Text;